
export enum TimeNumber {
  MIN = 60,
  DAYS = 365,
  MONTHS = 12,
  ROUND_VALUE = 100,
}